<template>
    <el-dialog
            v-model="dialogVisible"
            title="Редактирование аккаунта"
            width="40%"
            :before-close="handleClose">
        <div id="content">
            <el-card shadow="never">
                <template #header>
                    <div class="card-header">
                        <span>Контактные данные</span>
                    </div>
                </template>
                <el-row :gutter="20">
                <span class="ml-3 w-35 text-gray-600 inline-flex items-center">
                    Домен
                </span>
                    <el-input
                            v-model="plugin.domain"
                            class="w-50 m-2"
                            :prefix-icon="Link"
                            disabled
                    />
                </el-row>
                <el-row :gutter="20">
                <span class="ml-3 w-35 text-gray-600 inline-flex items-center">
                    Имя
                </span>
                    <el-input
                            v-model="plugin.name"
                            class="w-50 m-2"
                            placeholder="Имя"
                            :prefix-icon="User"
                            @input="changeFrom()"
                    />
                </el-row>
                <el-row :gutter="20">
                <span class="ml-3 w-35 text-gray-600 inline-flex items-center">
                    Телефон
                </span>
                    <el-input
                            v-model="plugin.phone"
                            class="w-50 m-2"
                            placeholder="Телефон"
                            :prefix-icon="PhoneFilled"
                            @input="changeFrom()"
                    />
                </el-row>
                <el-row :gutter="20">
                <span class="ml-3 w-35 text-gray-600 inline-flex items-center">
                    E-mail
                </span>
                    <el-input
                            v-model="plugin.email"
                            class="w-50 m-2"
                            placeholder="E-mail"
                            :prefix-icon="Message"
                            @input="changeFrom()"
                    />
                </el-row>
            </el-card>
            <br>
            <el-card shadow="never">
                <template #header>
                    <div class="card-header">
                        <span>Настройки виджета</span>
                    </div>
                </template>
                <el-row :gutter="20">
                <span class="ml-3 w-35 text-gray-600 inline-flex items-center">
                    Дата установки
                </span>
                    <el-input
                            v-model="plugin.date_install"
                            class="w-50 m-2"
                            placeholder="Дата установки"
                            :prefix-icon="Calendar"
                            disabled
                    />
                </el-row>
                <el-row :gutter="20">
                <span class="ml-3 w-35 text-gray-600 inline-flex items-center">
                    Платная подписка
                </span>
                    <el-switch
                            v-model="plugin.is_paid"
                            class="ml-2"
                            active-text="Платная"
                            inactive-text="Бесплатная"
                            @change="changeFrom"
                            style="--el-switch-on-color: #13ce66; --el-switch-off-color: #ff4949"
                    />
                </el-row>
                <el-row :gutter="20" v-if="plugin.is_paid">
                    <span class="ml-3 w-35 text-gray-600 inline-flex items-center">
                        Дата окончания подписки
                    </span>
                    <el-date-picker
                            v-model="plugin.date_paid"
                            value-format="DD.MM.YYYY"
                            format="DD.MM.YYYY"
                            type="date"
                            class="w-50 m-2"
                            placeholder="Дата"
                            :prefix-icon="Calendar"
                            @change="updatePaidDate"
                    />
                </el-row>
                <el-row :gutter="20" v-else>
                    <span class="ml-3 w-35 text-gray-600 inline-flex items-center">
                        Дата окончания демо периода
                    </span>
                    <el-date-picker
                            v-model="plugin.date_demo"
                            value-format="DD.MM.YYYY"
                            format="DD.MM.YYYY"
                            type="date"
                            class="w-50 m-2"
                            placeholder="Дата"
                            :prefix-icon="Calendar"
                            @change="updateDemoDate"
                    />
                </el-row>
            </el-card>
        </div>
        <template #footer>
              <span class="dialog-footer">
                <el-button @click="dialogVisible = false">Отмена</el-button>
                <el-button :disabled="saveEnable" type="primary" @click="saveWidget()">
                  Сохранить
                </el-button>
              </span>
        </template>
    </el-dialog>
</template>

<script>
import {Calendar, Link, Message, More, PhoneFilled, User} from "@element-plus/icons-vue";
import store from "@/components/store/store";

export default {
    name: "EditPluginInstall",
    computed: {
        Calendar() {
            return Calendar
        },
        Message() {
            return Message
        },
        PhoneFilled() {
            return PhoneFilled
        },
        Link() {
            return Link
        },
        More() {
            return More
        },
        User() {
            return User
        }
    },
    data() {
        return {
            dialogVisible: false,
            saveEnable: true,
            plugin: {
                id: 0,
                domain: '',
                email: '',
                is_paid: false,
                name: '',
                partner: '',
                phone: '',
                plugin: '',
                widget_id: 0,
                count_upload: 0,
                data_uninstall: '',
                date_demo: '',
                date_install: '',
                date_paid: '',
            },
            pluginOriginal: null
        }
    },
    methods: {
        handleClose() {
            this.dialogVisible = false;
        },
        openEditPluginInstall(plugin) {
            this.plugin = JSON.parse(JSON.stringify(plugin));
            this.pluginOriginal = JSON.parse(JSON.stringify(plugin));
            this.dialogVisible = true;
        },
        updateDemoDate(date) {
            this.plugin.date_demo = date;
            this.changeFrom();
        },
        updatePaidDate(date) {
            this.plugin.date_paid = date;
            this.changeFrom();
        },
        saveWidget() {
            this.dialogVisible = false;
            this.saveEnable = false;
            this.plugin.page = store.state.page;
            store.dispatch('updatePlugin', {
                plugin: this.plugin
            });
        },
        changeFrom() {
            if (JSON.stringify(this.plugin) !== JSON.stringify(this.pluginOriginal)) {
                this.saveEnable = !(this.plugin.is_paid === false && this.plugin.date_demo?.length
                    && this.plugin.phone.length && this.plugin.email.length && this.plugin.name.length ||
                    this.plugin.is_paid === true && this.plugin.date_paid?.length
                    && this.plugin.phone.length && this.plugin.email.length && this.plugin.name.length);
            } else {
                this.saveEnable = true;
            }
        }
    }
}
</script>

<style scoped>
.card-header {
    text-align: start;
}

.card-header span {
    color: silver;
}

.items-center {
    align-items: center;
}

.inline-flex {
    display: inline-flex;
}

.text-gray-600 {
    --un-text-opacity: 1;
    color: rgba(75, 85, 99, var(--un-text-opacity));
}

.w-35 {
    width: 14.75rem;
}

.ml-3 {
    margin-left: 0.75rem;
}
</style>